<script>
  import VideoPlayer from "./VideoPlayer.svelte";
  import PlaylistPane from "./PlaylistPane.svelte";
  import { active_video_store } from "./Utils/stores";
  import { sidebarToggled } from "./Utils/stores";
  import FinishedVideoPanel from "./FinishedVideoPanel.svelte";
  import { postWatchedVideo } from "./stores/authStore";
  import {update_video} from "./Utils/RouterUtils.svelte";
  import RelatedVideos from "./RelatedVideos.svelte";

  export let video;
  export let showModal;
  export let playlist = false;
  let video_finished = false;
  let dialog; // HTMLDialogElement

  function calculatePlaylistTitle(playlist, video) {
    if (!playlist) {
      return "";
    }
    return playlist.title ?? playlist.projectName;
  }
  $: playlistTitle = calculatePlaylistTitle(playlist, video);

  let title = "";
  $: {
    if (video_finished && playlist) {
      title = playlist.title ?? playlist.projectName
    } else {
      title  = video.videoTitle
    }
  }

  
  function resetPlayedLast() {
    video_finished = false;
  }

  function handle_video_ended() {
    video_finished = true;
    handle_soft_video_ended();
  }
  
  function toggle_sidebar() {
    if(window.innerWidth < 768) {
      if(sidebarState) {
        sidebarToggled.update(sidebarToggled => false);
      } else {
        sidebarToggled.update(sidebarToggled => true);
      }
    }
  }

  let sidebarState;

	sidebarToggled.subscribe((value) => {
		sidebarState = value;
	});

  async function handle_soft_video_ended() {
    let videoslug = null;
    let category = null;
    let playlistslug = null;
    let project = null;
    if (playlist) { playlistslug = playlist.slug.current; }
    if(video) { videoslug = video.slug.current; }
    if($active_video_store.active_category) { category = $active_video_store.active_category.slug.current; }
    if($active_video_store.active_project) { project = $active_video_store.active_project.slug.current; }
    await postWatchedVideo(videoslug, category, playlistslug, project);
  }

  $: if (dialog && showModal) {
    dialog.showModal();
  }
</script>

<dialog
  bind:this={dialog}
  id="openvideo"
  class="vec-p-0 vec-max-w-screen-2xl vec-max-h-[1024px] vec-w-[calc(100%-2.5rem)] vec-h-[calc(100%-2.5rem)] vec-mx-auto vec-rounded-2xl vec-rounded-bl-none vec-bg-white vec-overflow-visible"
  aria-hidden="true"
  on:close={() => {showModal = false;}}
  on:click|self={() => {dialog.close()}}

>
        <button type="button"
                data-dismiss="modal"
                aria-label="Close"
                class="vec-absolute vec--top-3 vec--right-3 vec-cursor-pointer vec-z-50 vec-flex vec-w-[50px] vec-h-[50px] !vec-bg-gradient-to-t vec-from-black vec-to-darkGrey vec-rounded-full vec-border-[6px] vec-border-lightGrey focus-visible:vec-outline-none"
                on:close={() => {showModal = false; update_video(null);}}
                on:click={() => {
          dialog.close();
          showModal = false;
          update_video(null);
        }}
        >
        <svg class="vec-fill-current vec-text-white vec-m-auto" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 18 18"><path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"></path></svg>
        </button>
    <div class="vec-relative vec-h-full vec-overflow-hidden vec-rounded-2xl vec-rounded-bl-none">
      <div class="modal-body vec-flex vec-flex-col vec-h-full vec-overflow-y-auto">
        <div class:vec-pl-10={playlist} class="vec-flex vec-flex-col sm:vec-flex-row vec-p-5 md:vec-p-10">
          <div class={playlist ? 'vec-w-full md:vec-w-2/3 md:vec-pr-8' : 'vec-w-full'}>
            {#if video_finished}
              <FinishedVideoPanel {video} {playlist} on:video-clicked={resetPlayedLast}/>
            {:else}
              <VideoPlayer
                {video}
                {title}
                on:video-ended={handle_video_ended}
                on:soft-video-end={handle_soft_video_ended}
              />

            {/if}
          </div>
          {#if playlist}
            <div id="playlist" class:open-playlist={sidebarState} class="vec-h-[100%] md:vec-w-1/3 vec-absolute vec-top-0 md:vec-top-0 md:vec-left-2/3 vec-bg-white vec-z-1 vec-shadow-lg vec-rounded-r-xl md:vec-rounded-none">
              
              <div id="playlistTab" class="cursor-pointer md:vec-hidden vec-absolute vec-left-[100%] vec-top-0 vec-z-1 vec-px-3 vec-py-1 vec-bg-white vec-shadow-lg vec-origin-bottom-left vec-rotate-90 vec-text-nowrap vec-text-center vec-rounded-t vec-text-xs" on:click={() => {
                toggle_sidebar();
              }}>
              {#if sidebarState}Hide{:else}View{/if}&nbsp;Playlist</div>
              <div class="vec-playlist-content vec-h-full vec-overflow-y-auto vec-relative vec-z-2 vec-bg-white vec-rounded-r-xl md:vec-rounded-none">
                <div class="vec-p-5 vec-py-10">
                <h3 class="vec-text-lg vec-my-4">
                  {playlistTitle}
                </h3>
                    <PlaylistPane
                      videos={playlist.videos}
                      activeVideoSlug={video.slug.current}
                      on:video-clicked={resetPlayedLast}
                    />
                </div>
              </div>
          </div>
          {/if}
        </div>
          
            <!-- Related Videos & Sharing --> 
            <div class="vec-w-full vec-mt-8 vec-mt-auto">
              <RelatedVideos video={video}/>
            </div>
      </div>
    </div>
</dialog>

<style>
@media only screen and (max-width: 767px) {
  #playlist {
    right:100%;
    width:80%;
    transition: right 0.3s ease-out;
  }

  #playlist.open-playlist {
    right:20%;
    z-index:2;
  }
  #playlistTab {
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  }
}

dialog::backdrop {
  background: rgba(107, 114, 128, 0.6);
}
</style>